import history from "@irati/utils/history"
import devToggles from "@irati/dev-toggles"
import {useFlexiMigration} from "./flexiMigration"

interface Props {
  skip?: boolean
}
export const useFlexiPointsMigrationRedirect = ({skip}: Props = {}) => {
  const {status} = useFlexiMigration()

  if (status === "MID" && !skip && devToggles.showPointsConversionMaintenance()) {
    history.push("/wallet/points-conversion")
  }
}
